module.exports = __webpack_public_path__ + "static/assets/5135680066e1eaa3812099d39e1e73c2.png";